import { render, staticRenderFns } from "./JobGroupHistory.vue?vue&type=template&id=76cf756c&"
import script from "./JobGroupHistory.vue?vue&type=script&lang=js&"
export * from "./JobGroupHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports